import React from "react";
import { Form, DatePicker, Select, Button } from "antd";
import moment from "moment";
import { useSelector } from "react-redux";

const { Option } = Select;

const dateFormat = "YYYY-MM-DD";
const layout = {
  style: { margin: "24px" },
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 7,
    span: 16,
  },
};

const ReportForm = ({ onSubmit, openNotificationWithIcon }) => {
  const [form] = Form.useForm();
  const teams = useSelector((state) => state?.team?.all);

  const onFinish = async (values) => {
    try {
      await onSubmit(values);
      form.resetFields();
    } catch (error) {
      openNotificationWithIcon(
        "error",
        "Form not submitted due to an error",
        JSON.stringify(
          error?.message || error?.errorResponse?.errorMessage || error
        )
      );
    }
  };

  return (
    <Form
      form={form}
      name="input-page"
      size="middle"
      onFinish={onFinish}
      {...layout}
    >
      <Form.Item
        name="date"
        label="Date"
        rules={[{ required: true, message: "Please select a date" }]}
      >
        <DatePicker
          style={{ width: "190px" }}
          format={dateFormat}
          disabledDate={(current) => current && current > moment().endOf("day")}
        />
      </Form.Item>
      <Form.Item
        name="storeIds"
        label="Store ID"
        rules={[
          { required: true, message: "Please select store ID" },
          {
            validator(_, value) {
              if (value && value.length > 15) {
                return Promise.reject(
                  new Error("You can select up to 15 store IDs only")
                );
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <Select
          mode="multiple"
          placeholder="Select store"
          style={{ width: "190px" }}
        >
          {teams.map((team) => (
            <Option key={team.id} value={team.id}>
              {team.id}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Button type="primary" htmlType="submit">
          Export Report
        </Button>
        <Button
          style={{ marginLeft: "24px" }}
          htmlType="button"
          onClick={() => form.resetFields()}
        >
          Reset Form
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ReportForm;
